import WorkerApiService from "../../workerApiServices";

class ConciliacaoBancariaService extends WorkerApiService {
 
    constructor() {
        super('/api/conciliacaoBancaria')
    }

    searchByDateInterval(conciliacaoBancariaInputDTO){
        return this.post('/searchByDateInterval', conciliacaoBancariaInputDTO)
    }

    conciliar(conciliacaoBancariaInputDTO){
        return this.post('/conciliar', conciliacaoBancariaInputDTO)
    }

    desfazerConciliacao(conciliacaoBancariaInputDTO){
        return this.post('/desfazerConciliacao', conciliacaoBancariaInputDTO)
    }

    searchConciliacaoProvisaoByUuidParcela(uuidParcela){
        let params = `?&uuidParcela=${uuidParcela}`
        return this.get(`/searchConciliacaoProvisaoByUuidParcela${params}`)
    }

}

export default ConciliacaoBancariaService